import { render, staticRenderFns } from "./StoryTwoView.vue?vue&type=template&id=2fb3e01a&"
import script from "./StoryTwoView.vue?vue&type=script&lang=js&"
export * from "./StoryTwoView.vue?vue&type=script&lang=js&"
import style0 from "./StoryTwoView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports